import { combineReducers } from 'redux';
import { LOGIN_COMPLETE, LOGOUT_COMPLETE } from '../actionType';

import { loginReducer } from './loginReducer';
import { utilityReducer } from './utilityReducer';
import { appointmentReducer } from './appointmentReducer';
import { licenseIDReducer } from './licenseIDReducer';
import { vehicleReducer } from './vehicleReducer';
import { userReducer } from './userReducer';

const appReducer = combineReducers({
    loginReducer,
    utilityReducer,
    appointmentReducer,
    licenseIDReducer,
    vehicleReducer,
    userReducer,
});

export default (state, action) => {
    if (action.type === LOGIN_COMPLETE || action.type === LOGOUT_COMPLETE) {
        return appReducer(undefined, action);
    }

    return appReducer(state, action);
};
